/**
 * Created by inonstelman on 1/6/15.
 */
(function () {
    'use strict';

    // @ngInject
    Decorators.$exceptionHandlerDecorator = function $exceptionHandlerDecorator($delegate, TrackJS) {

        return function $exceptionDecoratorHandlerFunction(exception, cause) {

            $delegate(exception, cause);

            // Track error and log anything else of interest.
            TrackJS && TrackJS.track(exception);
        };
    };


}());
